import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { Section, Reveal } from '../components/Section';
import { CtaBanner } from '../components/CtaBanner';
import { Disclaimer } from '../components/Disclaimer';
import { businessFocusCards } from '../data/site';
export function BusinessFocus() {
  return <>
      <Seo title="Business Focus | Futuramy Investment LLC" description="Futuramy Investment LLC focuses on business opportunities and strategic initiatives with a long-term perspective." path="/business-focus" data-id="element-194" data-mp="2t8iwr86t4sjo" />
      <PageHeader eyebrow="Business focus" title="Our Business Focus" subtitle="Futuramy Investment LLC focuses on business opportunities and strategic initiatives with a long-term perspective." data-id="element-195" data-mp="2kg791u32vj7e" />

      <Section data-id="element-196" data-mp="2ajcc3fmgdqv8">
        <Box borderTop="1px solid" borderColor="navy.200" data-id="element-197" data-mp="25iom8x9yng2l">
          {businessFocusCards.map((card, index) => <Reveal key={card.number} delay={index * 0.06} data-id="element-198" data-mp="2h6udqvu0hl0v" data-mpi={index}>
              <Flex direction={{
            base: 'column',
            md: 'row'
          }} gap={{
            base: 4,
            md: 16
          }} py={{
            base: 10,
            md: 14
          }} borderBottom="1px solid" borderColor="navy.100" align="flex-start" data-id="element-199" data-mp="2h59i12vynw1f">
                <Text fontSize={{
              base: '2xl',
              md: '3xl'
            }} fontWeight={600} color="navy.200" lineHeight={1} minW={{
              md: '120px'
            }} data-id="element-200" data-mp="2c5wuefx9mkxs">
                  {card.number}
                </Text>
                <Box maxW="760px" data-id="element-201" data-mp="2q1ihuinuowo3">
                  <Heading as="h2" fontSize={{
                base: 'xl',
                md: '2xl'
              }} mb={4} data-id="element-202" data-mp="2uxzi2b8br1hj">
                    {card.title}
                  </Heading>
                  <Text fontSize={{
                base: 'md',
                md: 'lg'
              }} color="navy.500" fontWeight={300} lineHeight={1.8} data-id="element-203" data-mp="1eipl8eed49p8">
                    {card.detailed}
                  </Text>
                </Box>
              </Flex>
            </Reveal>)}
        </Box>
      </Section>

      <Disclaimer data-id="element-204" data-mp="3h7z7ygcz2cue" />
      <CtaBanner data-id="element-205" data-mp="3h7g1pwwopcw7" />
    </>;
}